/**
 * Project Filters Component
 * Status filter dropdown
 * Aviation Dashboard Style
 */

import { Filter } from 'lucide-react';
import { type ProjectStatus } from '../../db';

interface ProjectFiltersProps {
  statusFilter: ProjectStatus | 'all';
  onStatusChange: (status: ProjectStatus | 'all') => void;
}

const statusOptions: { value: ProjectStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'ALL' },
  { value: 'draft', label: 'DRAFT' },
  { value: 'in_progress', label: 'IN_PROGRESS' },
  { value: 'review', label: 'REVIEW' },
  { value: 'completed', label: 'COMPLETED' },
  { value: 'exported', label: 'EXPORTED' },
];

export function ProjectFilters({ statusFilter, onStatusChange }: ProjectFiltersProps) {
  return (
    <div className="flex items-center gap-2">
      <Filter className="w-5 h-5 text-slate-500" />
      <select
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value as ProjectStatus | 'all')}
        className="px-3 py-2 bg-slate-900/50 border border-slate-600 rounded-lg font-mono text-sm text-slate-200 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-colors"
      >
        {statusOptions.map((option) => (
          <option key={option.value} value={option.value} className="bg-slate-800">
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
